<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><em>This book is dedicated to precious Mama,<br/>who smiled through my wedding anyway,<br/>and who still drives like a New York cabbie,<br/>shares her keen mind and talents to help others,<br/>and is always there for me as consoler,<br/>traveling companion, and friend</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7cd4d579